<template>
    <section>
        <!-- <div
      v-if="isMobile"
      class="flex items-center w-full mt-4 border-t dark:border-gray-700 dark:text-gray-500 dark:hover:text-gray-300"
    >
      <button
        class="block p-3 text-gray-700 border-r dark:border-gray-700 dark:text-gray-500 dark:hover:text-gray-300 dark:hover:bg-gray-800 hover:text-gray-800 hover:bg-gray-50"
        @click="share()"
      >
        Del artikkel
      </button>
    </div> -->
        <div class="flex items-center w-full mt-4 border-t dark:border-gray-700 dark:text-gray-500 dark:hover:text-gray-300">
            <div class="flex">
                <!-- <button
          class="block p-3 text-gray-700 border-r dark:border-gray-700 dark:text-gray-500 dark:hover:text-gray-300 dark:hover:bg-gray-800 hover:text-gray-800 hover:bg-gray-50"
          @click="share()"
        >
          Del artikkel
        </button> -->
                <ShareNetwork
                    v-for="network in networks"
                    :key="network.network"
                    :network="network.network"
                    :style="{backgroundColor: network.color}"
                    :url="sharing.url"
                    :title="sharing.title"
                    :description="sharing.description"
                    :quote="sharing.quote"
                    :hashtags="sharing.hashtags"
                    :twitter-user="sharing.twitterUser"
                    class="block w-10 h-10 p-3 text-gray-700 border-r cursor-pointer dark:border-gray-700 dark:text-gray-300 dark:hover:text-gray-200 dark:hover:bg-gray-800 hover:text-gray-800 hover:bg-gray-100">
                    <svg v-if="network.network == 'linkedin'" role="img" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <title>LinkedIn icon</title>
                        <path
                            d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                    <svg v-if="network.network == 'twitter'" role="img" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>Twitter icon</title>
                        <path
                            d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                    <svg v-if="network.network == 'facebook'" role="img" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <title>Facebook icon</title>
                        <path
                            d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                </ShareNetwork>
            </div>
            <button
                v-if="authenticated == 'y' && !isOpen"
                class="flex items-center h-10 pr-3 text-gray-700 border-r cursor-pointer bg-indigo-50 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300 dark:hover:text-gray-200 dark:hover:bg-gray-700 hover:text-gray-800"
                @click="createShareUrl">
                <div class="block w-10 h-10 p-3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        class="animate-spin"
                        :class="[loading ? 'flex' : 'hidden']">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        :class="[loading ? 'hidden' : 'flex']">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                    </svg>
                </div>
                <span class="text-sm font-semibold">Åpne i 24 timer</span>
            </button>
        </div>
        <modal :showing="showModal" :options="modalOptions" @close="showModal = false">
            <label for="email" class="flex flex-col">
                <div class="flex flex-col mb-4">
                    <span class="mb-2 text-xl font-semibold prose dark:prose-invert">Lag åpen artikkel</span>
                    <div class="text-sm prose dark:prose-invert">
                        <p>Klikk på linken og kopier adressen til den åpne artikkelen.</p>
                        <p>
                            <strong>Den delte artikkelen er gyldig i 24 timer.</strong>
                        </p>
                    </div>
                </div>

                <input
                    ref="copyText"
                    v-model="shareUrl"
                    type="text"
                    readonly
                    :class="{'bg-purple-100': copied}"
                    class="block w-full p-2 px-2 mt-1 mb-4 text-sm text-gray-900 border border-gray-200 rounded cursor-pointer form-input"
                    @click="copyToClip" />
            </label>

            <template #footer>
                <div class="flex items-center">
                    <span v-if="copied" class="flex items-center justify-center text-sm text-black dark:text-white">
                        <svg
                            class="h-6 mr-2 text-purple-600"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                        </svg>
                        Adressen er kopiert. Du kan lukke vinduet!</span
                    >
                </div>
            </template>
        </modal>
    </section>
</template>

<script>
import Modal from './Modal'
import axios from '../../../plugins/axios'

export default {
    components: {
        Modal,
    },
    props: {
        entry: {
            type: Number,
            required: true,
            default: null,
        },
        url: {
            type: String,
            required: true,
            default: '',
        },
        title: {
            type: String,
            required: true,
            default: '',
        },
        text: {
            type: String,
            required: false,
            default: '',
        },
        authenticated: {
            type: String,
            required: true,
            default: 'n',
        },
        isOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            token: window.csrfTokenValue,
            showModal: false,
            modalOptions: {
                modal: 'max-w-xl mx-4',
            },
            loading: false,
            shareUrl: '',
            copied: false,
            sharing: {
                url: this.url,
                title: this.title,
                description: this.text,
            },
            networks: [
                {
                    network: 'facebook',
                    name: 'Facebook',
                    icon: 'fab fah fa-lg fa-facebook-f',
                    color: 'transparent',
                },
                {
                    network: 'linkedin',
                    name: 'LinkedIn',
                    icon: 'fab fah fa-lg fa-linkedin',
                    color: 'transparent',
                },
                {
                    network: 'twitter',
                    name: 'Twitter',
                    icon: 'fab fah fa-lg fa-twitter',
                    color: 'transparent',
                },
            ],
        }
    },
    computed: {
        isMobile() {
            // return true
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            }

            return false
        },
    },

    methods: {
        copyToClip() {
            this.$refs['copyText'].focus()
            this.$refs['copyText'].select()

            try {
                var successful = document.execCommand('copy')
                this.copied = true
                setTimeout(() => {
                    this.copied = false
                }, 10000)
            } catch (err) {
                this.copied = false
            }
        },
        async createShareUrl(payload) {
            this.loading = true
            await axios
                .postForm('/actions/site/share/create', {
                    CRAFT_CSRF_TOKEN: this.token,
                    entryId: this.entry,
                })
                .then(({data}) => {
                    this.showModal = true
                    this.shareUrl = data.url
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false
                })
        },
        share() {
            if (navigator.share === undefined) {
                console.log('Error: Unsupported feature: navigator.share()')
                return
            }

            const title = this.title
            const text = this.preamble
            let url = document.location.href
            const canonicalElement = document.querySelector('link[rel=canonical]')
            if (canonicalElement !== null) {
                url = canonicalElement.href
            }

            navigator
                .share({title, text, url})
                .then(() => {})
                .catch((error) => {
                    window.location.reload(true)
                })
        },
    },
}
</script>
